module.exports = i18next;